import { forwardRef } from 'react';
import { Input } from '@chakra-ui/react';
import { NumericFormat } from 'react-number-format';
import { AmountUtil } from '@/data/AmountUtil';
import { Control, Controller } from 'react-hook-form';
import { Field } from "@/components/ui/field"
import { InputGroup } from "@/components/ui/input-group"
import { BiWallet } from 'react-icons/bi';

interface CustomAmountInputProps {
  value?: string | number;
  onChange?: (value: string) => void;
  decimalPlaces?: number;
  multiplier?: number;
  [key: string]: any;
}

export const CustomAmountInput = forwardRef<HTMLInputElement, CustomAmountInputProps>(({ value, onChange, decimalPlaces, multiplier = 1, ...props }, ref) => {
  // Convert the stored value (which may already be multiplied) to display value
  const displayValue = typeof value === 'number' ? value / multiplier : value;
  
  return (
    <NumericFormat
      customInput={Input} // Use Chakra Input as the base component
      textAlign='right'
      thousandSeparator="'"
      decimalSeparator="."
      decimalScale={decimalPlaces ?? 2}
      fixedDecimalScale={true}
      getInputRef={ref}
      value={displayValue}
      onValueChange={(values) => {
        if (onChange) {
          const parsedValue = AmountUtil.parse(values.value);
          const multipliedValue = parsedValue * multiplier;
          onChange(multipliedValue);
        }
      }}
      {...props}
    />
  );
});

export const AmountInputController = ({ control, name, readOnly, label, icon, decimalPlaces, multiplier, ...props }:
  { control: Control<any, any>, name: string, readOnly: boolean, label?: string, icon?: React.ReactElement, decimalPlaces?: number, multiplier?: number, [key: string]: any }) => {
  const labelText = label ?? 'Summe';
  const validation = {
    required: `${labelText} eingeben`,
    validate: (value: number) => value > 0 || `${labelText} eingeben`
  };
  return (<Controller control={control} name={name}
    rules={validation}
    render={({ field: { value, name, onChange, onBlur, ref }, fieldState: { error, invalid } }) => {
      //console.log(error);
      return (
        <Field id={name} label={labelText} required invalid={invalid} errorText={error?.message} disabled={readOnly}>
          <InputGroup startElement={icon ?? <BiWallet color='blue' />}>
            <CustomAmountInput value={value} onChange={onChange} onBlur={onBlur} decimalPlaces={decimalPlaces} multiplier={multiplier} ref={ref} {...props} />
          </InputGroup>
        </Field>
      )
    }} />)
}
